import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import ClearInputButton from '#components/a/form/ClearInputButton'

function FileInput({selectedFile, onFileChanged, placeholder, accept}) {
  const fileInputRef = useRef()
  const hasFile = !!selectedFile?.name
  const fileName = hasFile ? selectedFile.name : placeholder
  const nameModifier = hasFile ? '' : 'fileName__placeholder'

  const resetFile = () => {
    fileInputRef.current.value = ''
    onFileChanged(null)
  }

  return (
    <div className="fileInput">
      <label htmlFor="fileInputElem">
        <div className="uploadClip" />
        <div className={`fileName ${nameModifier}`}>{fileName}</div>
        <input
          id="fileInputElem"
          ref={fileInputRef}
          type="file"
          accept={accept}
          onChange={event => onFileChanged(event.target.files[0])}
        />
      </label>
      {hasFile && <ClearInputButton onPress={resetFile} />}
    </div>
  )
}

FileInput.propTypes = {
  selectedFile: PropTypes.object,
  onFileChanged: PropTypes.func,
  placeholder: PropTypes.string,
  accept: PropTypes.string,
}

export default FileInput
